//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as myProfileAction from '../action/myProfileAction';
import * as uiAction from '../action/uiAction';
import * as helpAction from '../action/helpAction';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';

//Add
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';
import TextareaAutosize from 'react-textarea-autosize';
import { imageResize } from '../func/imageResizeRotate';

//Part
import PartPageTitle from './PartPageTitle';
//Dialog
import DialogConfirm from './DialogConfirm';
//Icon
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto';

//JSON
var contactItem = require('../data/contactItem.json');
var packageJson = require('../../package.json');


class Comp extends React.Component {
  constructor(props) {
		super(props);

    this.state = {
      sendDialogVisible: false,
      contactEmail: '',
      contactEmailErr: '',
      contactText: '',
      contactTextErr: '',
      imgUploadThumb: '',
      contact: '',
      contactSended: false,
    }

	}

  componentDidMount() {
    document.title = 'お問い合わせ - パートナーズ';
    if (this.props.my.setting.email) {
      this.setState({contactEmail: this.props.my.setting.email});
    }
    let type = this.props.match.params.type;
    if (type === 'duplicate') {
      this.setState({ form: true });
      this.setState({ contactText: '旧アカウントのログイン情報の再送信いたします。そのままお問い合わせを送信してください。' });
    }
    else if (type === 'birthdayEdit') {
      this.setState({ form: true });
      this.setState({ contactText: '・正しい生年月日を記入してください \n\n 年 月 日' });
    }
    else if (type === 'sexEdit') {
      this.setState({ form: true });
      this.setState({ contactText: '・正しい性別を記入してください \n\n' });
    }
  }

  _selectTemplate(title, text) {
    if (this.state.contactText.length > 0) {
      if(window.confirm('すでに記入されている問合せ内容を書き換えてもいいですか？')) {
        this.setState({ contactText: text });
      }
    }
    else {
      this.setState({ contactText: text });
    }
    this.setState({ form: true });
  }

  async _imageLoad(file) {
    await imageResize(file, 800)
    .then((res) => {
      this.setState({imgUploadThumb:res.uri});
    })
    .catch((err) => {
      this.setState({imgUploadThumb:''});
      this.props.snackOpen('error', err.comment , 5000)
    })
  }

  _contactEmailEdit(value) {
    value = value.replace(/[ 　]/g, '');
    this._contactEmailCheck(value);
    this.setState({contactEmail: value});
  }
  _contactEmailCheck(value) {
    if (value.match(/^[a-zA-Z0-9]+[a-zA-Z0-9!#$%&*+-/=?^_`{}|~.]+@[a-zA-Z0-9-._]+\.[a-z]+$/) == null) {
      this.setState({contactEmailErr: 'メールアドレスが正しくありません'});
    }
    else {
      this.setState({contactEmailErr: ''});
    }
  }
  _contactTextEdit(value) {
    this._contactTextCheck(value);
    this.setState({contactText: value});
  }
  _contactTextCheck(value) {
    if (value.length === 0) {
      this.setState({contactTextErr: 'お問い合わせ内容を記入してください'});
    }
    else if (value.length > 1000) {
      this.setState({contactTextErr: '1000文字以内で記入してください'});
    }
    else {
      this.setState({contactTextErr: ''});
    }
  }
  async _confirm() {
    await this._contactEmailCheck(this.state.contactEmail);
    await this._contactTextCheck(this.state.contactText);
    if (this.state.contactEmailErr.length > 0) {
      let elem = document.getElementById('email_block');
      let rect = elem.getBoundingClientRect();
      window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
    }
    else if (this.state.contactTextErr.length > 0) {
      let elem = document.getElementById('text_block');
      let rect = elem.getBoundingClientRect();
      window.scrollTo(0, (window.pageYOffset + rect.top - document.getElementById('header_menu').clientHeight));
    }
    else {
      this.setState({sendDialogVisible: true});
    }
  }

  _submit() {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('version', packageJson.version);
    params.append('contactSubject', 'お問い合わせ');
    params.append('contactEmail', this.state.contactEmail);
    params.append('contactText', this.state.contactText);
    params.append('contactPhotoBase64', this.state.imgUploadThumb);
    return axios.post(config.apiUri + "contactApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      if(res.data.bool) {
        this.setState({
          form: false,
          contactText: '',
          imgUploadVisible: false,
          imgUploadThumb: '',
          sendDialogVisible: false,
          contactSended: true,
        });
      }
      else {
        this.props.snackOpen('error', res.data.comment, 5000);
      }
    })
    .catch((err) => {
      alert( config.apiErrComment );
    })
  }

  render() {

    return (
      <div>
        <PartPageTitle
          title={'お問い合わせ'}
          onback={ '/' }
        />
        <div>
          {
            (this.state.contactSended) ? (
              <div style={{maxWidth:'400px', margin:'auto'}}>
                <div style={{padding:'10px'}}>
                  12時間以内にカスタマーサポートより、回答させていただきますので暫くお待ちください。
                </div>
                <div style={{padding:'10px'}}>

                  メールアドレスに自動応答メールを送信いたしました。<br />
                  自動応答メールが受信されていない場合、サポートからの回答が返信できませんので、
                  メールアドレスのお間違いやメール受信設定をご確認いただき、再度お問い合わせを送信いただけますようお願い致します。
                </div>
              </div>
            ): (
              <div style={{maxWidth:'600px', margin:'auto'}}>
                <div>
                  <div style={{padding:'10px'}}>
                    <div style={{margin:'10px'}}>
                      <div>サービスの使い方はヘルプにも掲載しておりますのでご確認いただければ幸いです。</div>
                      <div>
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this.props.history.push('/help/') }
                        >
                          ヘルプ
                        </Button>

                      </div>
                    </div>

                    <div style={{margin:'10px'}}>
                      <div>ご質問内容を選択してください</div>
                      <div style={{lineHeight:'2.8em'}}>

                        {
                          contactItem.map((value, index) => {
                            return (
                              <span key={index}>
                                <Button
                                  variant="outlined"
                                  color="primary"
                                  onClick={ () => this._selectTemplate(value.title, value.text) }
                                >
                                  {value.title}
                                </Button>
                                &nbsp;
                              </span>
                            )
                          })
                        }
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this.props.history.push('/setting/email/') }
                        >
                          メールアドレスを変更
                        </Button>
                        &nbsp;
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this.props.history.push('/setting/stop/') }
                        >
                          サービスを一時停止する
                        </Button>
                        &nbsp;
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this.props.helpOpen('id',94) }
                        >
                          退会方法
                        </Button>
                        &nbsp;

                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this._selectTemplate('その他のご質問', '・お問い合わせ内容を記入してください') }
                        >
                          その他のご質問
                        </Button>
                        &nbsp;
                        <Button
                          variant="outlined"
                          color="primary"
                          onClick={ () => this._selectTemplate('改善点・ご要望', '・改善点やご要望がございましたらご記入いただければ幸いです') }
                        >
                          改善点・ご要望
                        </Button>
                      </div>
                    </div>
                    <div style={{margin:'10px',color:'#666',fontSize:'0.9em'}}>
                      ※原則１２時間以内に回答させていただいております。
                    </div>
                    <div style={{margin:'10px',color:'#666',fontSize:'0.9em'}}>
                      ※他会員へのご伝言、個人情報に関わる内容、アカウントの強制停止の解除、回答済の内容等、回答できない場合がございますので予めご了承お願い致します。
                    </div>
                    {
                      (this.state.form) && (
                        <div>
                          <div style={{margin:'10px'}} id='email_block'>
                            <h2>メールアドレス</h2>
                            <div>
                              <input
                                value={this.state.contactEmail}
                                onChange={(e) => this._contactEmailEdit(e.target.value)}
                                type="email"
                                style={{fontSize:'1.2em'}}
                                className="input_blue round6"
                              />
                              <div style={{color:'red'}}>{this.state.contactEmailErr}</div>

                            </div>
                          </div>
                          <div style={{margin:'10px'}} id='text_block'>
                            <h2>お問い合わせ内容</h2>
                            <div>
                              <TextareaAutosize
                                value={this.state.contactText}
                                className="input_blue round6"
                                onChange={(e) => this._contactTextEdit(e.target.value)}
                                style={{
                                  fontSize: '1.2em',
                                }}
                                minRows={6}
                              >
                              </TextareaAutosize>
                              <div style={{color:'red'}}>{this.state.contactTextErr}</div>
                            </div>
                          </div>

                          <div style={{margin:'10px'}} id='photo_block'>
                            <Button
                              variant="outlined"
                              color="primary"
                              onClick={ () => this.setState({imgUploadVisible: (this.state.imgUploadVisible ? false: true) }) }
                            >
                              画像がある場合
                            </Button>
                            {
                              (this.state.imgUploadVisible) && (
                                <div>
                                  {
                                    (this.state.imgUploadThumb) ?
                                    <label htmlFor="photo_file" style={{cursor:"pointer"}}>
                                      <div style={{textAlign:'center', margin:'5px', position:'relative'}}>
                                        <div align='center' style={{padding:'5px', position:'relative'}}>
                                            <img style={{ maxWidth:'160px' }} src={this.state.imgUploadThumb} id='thumb' alt='' />
                                        </div>
                                      </div>
                                    </label>
                                    :
                                    <div>
                                      <div align='center' >
                                        <label htmlFor="photo_file" style={{display:'block'}}>
                                          <IconButton component="span">
                                            <AddAPhotoIcon style={{fontSize:'2em'}}/>
                                          </IconButton>
                                        </label>
                                      </div>
                                    </div>
                                  }
                                  <input
                                    type='file'
                                    id='photo_file'
                                    accept='image/*'
                                    onChange={ (e) => {
                                      this._imageLoad(e.target.files[0]);
                                      e.target.value = null;
                                    }}
                                    style={{opacity:'0'}}
                                  />
                                </div>
                              )
                            }
                          </div>

                          <div align='center' style={{padding:'10px'}}>
                            <Button
                              variant="contained"
                              color="primary"
                              style={{minWidth:'240px'}}
                              onClick={ () => this._confirm() }
                              disabled={ ((this.state.contactEmail && !this.state.contactEmailErr) && (this.state.contactText && !this.state.contactTextErr)) ? false : true }
                            >
                              <span style={{fontSize:'1.4em'}}>送信する</span>
                            </Button>
                          </div>
                        </div>
                      )

                    }
                  </div>
                </div>

                <DialogConfirm
                  open={ this.state.sendDialogVisible }
                  title={'お問い合わせ'}
                  content={'お問い合わせを送信してもいいですか？'}
                  apply={ () => this._submit() }
                  close={ () => this.setState({sendDialogVisible: false}) }
                />
              </div>
            )
          }

        </div>
      </div>
    )
  }
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...myProfileAction,
    ...uiAction,
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
